import { supabase } from './supabase'

const WORKER_URL = 'https://beseter-leaked-password-check.tom-schmidt82.workers.dev'

const toHex = (buf) =>
  [...new Uint8Array(buf)].map((b) => b.toString(16).padStart(2, '0')).join('').toUpperCase()

/**
 * Free stand-in for Supabase's Pro-only "leaked password" toggle, using
 * HaveIBeenPwned's free Pwned Passwords API. The password is hashed here and
 * only the first 5 hex characters of the SHA-1 ever leave the browser
 * (k-anonymity range query) — neither the Worker nor HaveIBeenPwned ever see
 * the real password or the full hash.
 *
 * Fails open: any error (offline, rate-limited, Worker down) resolves to
 * `{ breached: false }` rather than blocking someone from signing in.
 */
export async function isPasswordBreached(password) {
  try {
    const digest = await crypto.subtle.digest('SHA-1', new TextEncoder().encode(password))
    const hash = toHex(digest)
    const prefix = hash.slice(0, 5)
    const suffix = hash.slice(5)

    const { data: { session } } = await supabase.auth.getSession()
    if (!session) return { breached: false }

    const res = await fetch(WORKER_URL, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        authorization: `Bearer ${session.access_token}`,
      },
      body: JSON.stringify({ hashPrefix: prefix }),
    })
    if (!res.ok) return { breached: false }
    const { checked, suffixes } = await res.json()
    if (!checked) return { breached: false }

    // Each line is "SUFFIX:COUNT". A count of 0 is HaveIBeenPwned's padding
    // (requested via Add-Padding above) to obscure real matches from network
    // observers — only a positive count is a real breach.
    const line = suffixes.split('\n').find((l) => l.trim().startsWith(suffix))
    const count = line ? Number(line.split(':')[1]) : 0
    return { breached: count > 0, count }
  } catch {
    return { breached: false }
  }
}
